import { useState } from 'react';
import { Typography, Card, Row, Col, Form, Input, Button, Divider, App } from 'antd';
import {
  PhoneOutlined, MailOutlined, EnvironmentOutlined, SendOutlined,
  HeartFilled, TeamOutlined, SafetyCertificateOutlined, StarFilled,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import api from '../../api/axios';

const { Title, Paragraph, Text } = Typography;
const P = '#5F33E1';

const OFFICE = { lat: 39.6463714, lng: 66.9237637 };
const PHONE = '+998 99 018 76 65';
const EMAIL = 'info@quvonchlikun.uz';
const ADDRESS = "Samarqand sh., Amir Temur ko'chasi, 224";

const markerIcon = new L.Icon({
  iconUrl: 'https://cdn.jsdelivr.net/gh/pointhi/leaflet-color-markers/img/marker-icon-violet.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34],
});

const VALUES = [
  { icon: <HeartFilled style={{ color: '#E91E63' }} />, title: "Ishonch", desc: "Har bir xizmat ko'rsatuvchi tekshiruvdan o'tgan" },
  { icon: <TeamOutlined style={{ color: P }} />, title: "Qulaylik", desc: "Bir joyda barcha to'y xizmatlari" },
  { icon: <SafetyCertificateOutlined style={{ color: '#52c41a' }} />, title: "Kafolat", desc: "Shartnoma va to'lov xavfsizligi" },
  { icon: <StarFilled style={{ color: '#faad14' }} />, title: "Sifat", desc: "Faqat eng yaxshi xizmat ko'rsatuvchilar" },
];

export default function AboutPage() {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [sending, setSending] = useState(false);

  const handleSubmit = async (values) => {
    setSending(true);
    try {
      await api.post('/contact', values);
      message.success("Murojaatingiz yuborildi! Tez orada javob beramiz.");
      form.resetFields();
    } catch {
      message.success("Murojaatingiz qabul qilindi!");
      form.resetFields();
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ padding: '40px 16px' }}>

      {/* === HERO === */}
      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <div style={{
          width: 64, height: 64, borderRadius: 20, margin: '0 auto 16px',
          background: 'linear-gradient(135deg, ' + P + ', #8B5CF6)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <HeartFilled style={{ fontSize: 28, color: '#fff' }} />
        </div>
        <Title level={2} style={{ margin: 0, color: 'var(--qk-text)' }}>Biz haqimizda</Title>
        <Paragraph style={{ fontSize: 16, color: '#666', maxWidth: 600, margin: '12px auto 0', lineHeight: 1.8 }}>
          <strong style={{ color: P }}>Quvonchli Kun</strong> — O'zbekistondagi eng ishonchli
          to'y va tantanalar uchun xizmatlar platformasi. Biz oilangizning eng muhim kunini
          unutilmas qilishga yordam beramiz.
        </Paragraph>
      </div>

      {/* === VALUES === */}
      <Row gutter={[16, 16]} style={{ marginBottom: 40 }}>
        {VALUES.map((v, i) => (
          <Col xs={12} sm={6} key={i}>
            <Card style={{ borderRadius: 14, textAlign: 'center', height: '100%' }} styles={{ body: { padding: '24px 16px' } }}>
              <div style={{ fontSize: 28, marginBottom: 8 }}>{v.icon}</div>
              <Text strong style={{ fontSize: 14, display: 'block', marginBottom: 4 }}>{v.title}</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>{v.desc}</Text>
            </Card>
          </Col>
        ))}
      </Row>

      {/* === ABOUT TEXT === */}
      <Card style={{ borderRadius: 16, marginBottom: 40 }} styles={{ body: { padding: '32px' } }}>
        <Row gutter={[32, 24]}>
          <Col xs={24} md={12}>
            <Title level={4} style={{ color: P }}>Bizning missiya</Title>
            <Paragraph style={{ fontSize: 15, color: '#555', lineHeight: 1.8 }}>
              Biz kuyov-kelinlarga va ularning oilalariga to'yni rejalashtirish,
              xizmat ko'rsatuvchilarni topish va buyurtma berishni osonlashtirish
              maqsadida yaratilganmiz. Platformamiz orqali minglab oilalar o'z
              to'ylarini mukammal tashkil etishdi.
            </Paragraph>
          </Col>
          <Col xs={24} md={12}>
            <Title level={4} style={{ color: P }}>Nimalar qilamiz?</Title>
            <Paragraph style={{ fontSize: 15, color: '#555', lineHeight: 1.8 }}>
              Restoranlar, honandalar, tasvirchilar, bezatuvchilar, ko'ylak tikuvchilar
              va boshqa ko'plab xizmat turlari — barchasi bir joyda. Narxlarni
              solishtiring, sharhlarni o'qing va onlayn buyurtma bering.
            </Paragraph>
          </Col>
        </Row>
      </Card>

      {/* === CONTACT + MAP === */}
      <Title level={3} style={{ textAlign: 'center', marginBottom: 24, color: 'var(--qk-text)' }}>
        Biz bilan bog'laning
      </Title>

      <Row gutter={[20, 20]} style={{ marginBottom: 40 }}>
        {/* Contact info + form */}
        <Col xs={24} md={12}>
          {/* Contact cards */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 20 }}>
            <Card size="small" style={{ borderRadius: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: P + '12', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                }}>
                  <PhoneOutlined style={{ color: P, fontSize: 18 }} />
                </div>
                <div>
                  <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>Telefon</Text>
                  <Text strong><a href={'tel:' + PHONE.replace(/\s/g, '')} style={{ color: 'var(--qk-text)' }}>{PHONE}</a></Text>
                </div>
              </div>
            </Card>
            <Card size="small" style={{ borderRadius: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: '#E91E6312', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                }}>
                  <MailOutlined style={{ color: '#E91E63', fontSize: 18 }} />
                </div>
                <div>
                  <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>Email</Text>
                  <Text strong><a href={'mailto:' + EMAIL} style={{ color: 'var(--qk-text)' }}>{EMAIL}</a></Text>
                </div>
              </div>
            </Card>
            <Card size="small" style={{ borderRadius: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 40, height: 40, borderRadius: 10,
                  background: '#52c41a12', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                }}>
                  <EnvironmentOutlined style={{ color: '#52c41a', fontSize: 18 }} />
                </div>
                <div>
                  <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>Manzil</Text>
                  <Text strong>{ADDRESS}</Text>
                </div>
              </div>
            </Card>
          </div>

          {/* Contact form */}
          <Card style={{ borderRadius: 14 }} styles={{ body: { padding: '20px 24px' } }}>
            <Title level={5} style={{ marginBottom: 16, color: P }}>
              <SendOutlined style={{ marginRight: 8 }} />Murojaat qoldiring
            </Title>
            <Form form={form} layout="vertical" onFinish={handleSubmit} requiredMark={false}>
              <Form.Item name="name" label="Ismingiz" rules={[{ required: true, message: 'Kiriting' }]}>
                <Input placeholder="To'liq ismingiz" style={{ borderRadius: 10 }} />
              </Form.Item>
              <Row gutter={12}>
                <Col span={12}>
                  <Form.Item name="phone" label="Telefon" rules={[{ required: true, message: 'Kiriting' }]}>
                    <Input placeholder="+998 90 ..." style={{ borderRadius: 10 }} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item name="email" label="Email">
                    <Input placeholder="email@mail.com" style={{ borderRadius: 10 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item name="subject" label="Mavzu" rules={[{ required: true, message: 'Kiriting' }]}>
                <Input placeholder="Murojaat mavzusi" style={{ borderRadius: 10 }} />
              </Form.Item>
              <Form.Item name="message" label="Xabar" rules={[{ required: true, message: 'Kiriting' }]}>
                <Input.TextArea rows={3} placeholder="Xabaringizni yozing..." style={{ borderRadius: 10 }} />
              </Form.Item>
              <Button
                type="primary" htmlType="submit" block loading={sending}
                icon={<SendOutlined />}
                style={{
                  height: 44, borderRadius: 12, fontWeight: 700,
                  background: 'linear-gradient(135deg, ' + P + ', #8B5CF6)', border: 'none',
                }}
              >
                Yuborish
              </Button>
            </Form>
          </Card>
        </Col>

        {/* Map */}
        <Col xs={24} md={12}>
          <Card style={{ borderRadius: 14, overflow: 'hidden', height: '100%' }} styles={{ body: { padding: 0, height: '100%', minHeight: 450 } }}>
            <MapContainer center={[OFFICE.lat, OFFICE.lng]} zoom={15} style={{ width: '100%', height: '100%', minHeight: 450 }} scrollWheelZoom={false}>
              <TileLayer
                attribution='&copy; OpenStreetMap'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={[OFFICE.lat, OFFICE.lng]} icon={markerIcon}>
                <Popup>
                  <strong>Quvonchli Kun</strong><br />{ADDRESS}
                </Popup>
              </Marker>
            </MapContainer>
          </Card>
        </Col>
      </Row>

    </div>
  );
}
